import { memo } from "react";
import type { IconProps } from "types";

const Settings = ({ width = "20", height = "20" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_276_2842)">
      <path d="M19 0H0V19H19V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M7.23706 17.0885C5.91058 16.6935 4.72985 15.9603 3.79492 14.9888C4.1437 14.5755 4.35389 14.0414 4.35389 13.4582C4.35389 12.1465 3.29056 11.0832 1.97889 11.0832C1.89954 11.0832 1.8211 11.0871 1.74376 11.0947C1.63839 10.5795 1.58305 10.0461 1.58305 9.49986C1.58305 8.67233 1.71003 7.87445 1.94555 7.12462C1.95665 7.12478 1.96776 7.12486 1.97889 7.12486C3.29056 7.12486 4.35389 6.06153 4.35389 4.74986C4.35389 4.3733 4.26625 4.01721 4.11029 3.70089C5.02581 2.84961 6.14325 2.21252 7.38284 1.86938C7.77563 2.6393 8.57612 3.16653 9.49972 3.16653C10.4233 3.16653 11.2238 2.6393 11.6166 1.86938C12.8562 2.21252 13.9736 2.84961 14.8891 3.70089C14.7332 4.01721 14.6456 4.3733 14.6456 4.74986C14.6456 6.06153 15.7089 7.12486 17.0206 7.12486C17.0317 7.12486 17.0428 7.12478 17.0539 7.12462C17.2894 7.87445 17.4164 8.67233 17.4164 9.49986C17.4164 10.0461 17.3611 10.5795 17.2557 11.0947C17.1783 11.0871 17.0999 11.0832 17.0206 11.0832C15.7089 11.0832 14.6456 12.1465 14.6456 13.4582C14.6456 14.0414 14.8557 14.5755 15.2045 14.9888C14.2696 15.9603 13.0889 16.6935 11.7624 17.0885C11.4562 16.1308 10.559 15.4374 9.49972 15.4374C8.44047 15.4374 7.5432 16.1308 7.23706 17.0885Z"
        stroke="currentColor"
        strokeWidth="1.43939"
        strokeLinejoin="round"
      />
      <path
        d="M9.50028 12.2707C11.0306 12.2707 12.2711 11.0301 12.2711 9.49984C12.2711 7.96955 11.0306 6.729 9.50028 6.729C7.96999 6.729 6.72945 7.96955 6.72945 9.49984C6.72945 11.0301 7.96999 12.2707 9.50028 12.2707Z"
        stroke="currentColor"
        strokeWidth="1.43939"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_276_2842">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Settings);
